import * as Api from '@ViewModels';
import moment from 'moment-timezone';
import { BriefDayGroup, groupBriefsByDay } from '../../../../../pages/MeetingPrepBriefs/helpers';

export const nextUpcomingBrief = (
	briefs: Api.IMeetingPrepBrief[],
	now: Date = new Date()
): Api.IMeetingPrepBrief | undefined => {
	let nearest: Api.IMeetingPrepBrief | undefined;
	let nearestTime = Number.POSITIVE_INFINITY;

	briefs.forEach(brief => {
		if (brief.status !== 'Success' || !brief.meetingStartTime) {
			return;
		}
		const startTime = new Date(brief.meetingStartTime).getTime();
		if (startTime > now.getTime() && startTime < nearestTime) {
			nearest = brief;
			nearestTime = startTime;
		}
	});

	return nearest;
};

export const todayPreppedDay = (
	briefs: Api.IMeetingPrepBrief[],
	timeZone: string,
	now: Date = new Date()
): BriefDayGroup | undefined => {
	const todayKey = moment(now).tz(timeZone).format('YYYY-MM-DD');
	return groupBriefsByDay(briefs, timeZone).find(group => group.key === todayKey && group.preppedCount > 0);
};

const coversDay = (day: moment.Moment, weekendDelivery: boolean) =>
	weekendDelivery || (day.isoWeekday() >= 1 && day.isoWeekday() <= 5);

const advanceToCoveredDay = (from: moment.Moment, weekendDelivery: boolean) => {
	const day = from.clone();
	for (let index = 0; index < 7 && !coversDay(day, weekendDelivery); index++) {
		day.add(1, 'day');
	}
	return day;
};

const periodOfDay = (hour: number): string => {
	if (hour < 12) {
		return 'morning';
	}
	return hour < 17 ? 'afternoon' : 'evening';
};

export const nextDeliveryLabel = (
	template: Api.MeetingPrepTemplate,
	timeZone: string,
	now: Date = new Date()
): string => {
	const localNow = moment(now).tz(timeZone);
	const weekendDelivery = !!template.weekendDelivery;
	const isEvening = template.deliveryTiming === Api.MeetingPrepDeliveryTiming.EveningBefore;
	const sendHour = template.sendHourLocal ?? (isEvening ? 19 : 7);

	let coverage = advanceToCoveredDay(localNow.clone().add(1, 'day').startOf('day'), weekendDelivery);
	let delivery = isEvening ? coverage.clone().subtract(1, 'day') : coverage.clone();

	if (delivery.isSame(localNow, 'day') && localNow.hour() >= sendHour) {
		coverage = advanceToCoveredDay(coverage.clone().add(1, 'day'), weekendDelivery);
		delivery = isEvening ? coverage.clone().subtract(1, 'day') : coverage.clone();
	}

	const period = periodOfDay(sendHour);
	if (delivery.isSame(localNow, 'day')) {
		return `this ${period}`;
	}
	if (delivery.isSame(localNow.clone().add(1, 'day'), 'day')) {
		return `tomorrow ${period}`;
	}
	return `${delivery.format('dddd')} ${period}`;
};

export const hasEverDelivered = (template: Api.MeetingPrepTemplate): boolean => !!template.lastRunDate;

export const spokenMeetingTime = (brief: Api.IMeetingPrepBrief, timeZone: string): string =>
	brief.meetingStartTime ? moment(brief.meetingStartTime).tz(timeZone).format('h:mm') : '';
